import { CommandTemplate } from '../commandTemplate/commandTemplate';
import { HasCommands } from '../../services/command/command.service';
import { Trigger } from '../trigger/trigger';

export class JobDetail implements HasCommands {

  static ENTITY_TYPE: string = 'JobDetail';

  key: { name: string; group: string };
  description: string | null;
  jobClass: string;
  commands: CommandTemplate[];
  jobTriggers: Trigger[];

  constructor(payload?: any) {
    if (payload) {
      this.key = payload.key;
      this.description = payload.description ?? null;
      this.jobClass = payload.jobClass;
      this.commands = (payload.commands ?? []).map((command: any) => new CommandTemplate(command));
      this.jobTriggers = (payload.jobTriggers ?? []).map((trigger: any) => new Trigger(trigger));
    }
  }

  getEntityType(): string {
    return JobDetail.ENTITY_TYPE;
  }

  getEntityId(): string {
    return this.key ? `${this.key.group}/${this.key.name}` : undefined;
  }

  getCollectionRoute(): string {
    return '/settings/job-admin';
  }
}
